  <!-- author omkar khamkar 16-02-2026-->
<!-- Added by Vipul on 25-09-2026 -->
<ng-template #selectTemplate let-row>
  <mat-checkbox
    [checked]="!!row.selected"
    (change)="toggleRowSelection(row, $event.checked)">
  </mat-checkbox>
</ng-template>

<ng-template #nameTemplate let-row>
  {{ row.createdBy || '-' }}
</ng-template>

<ng-template #noteTemplate let-row>
  <span class="note-cell">
    {{ row.note }}
  </span>
</ng-template>

<ng-template #createdTemplate let-row>
  {{ row.createdOn | date:'MM/dd/yyyy' }}
</ng-template>

<ng-template #actionTemplate let-row>
  <div class="action-icons">

    <span
      class="mark-read-tooltip-wrap"
      matTooltip="Mark as read"
      [matTooltipDisabled]="row.isRead || isRowActionDisabled(row)"
      matTooltipPosition="above"
      matTooltipClass="notes-mark-read-tooltip">

      <wm-common-icon
        class="action-icon mark-read"
        [class.read]="row.isRead"
        [class.icon-disabled]="isRowActionDisabled(row)"
        [data]="{ iconName: markReadIcon }"
        (click)="markAsRead(row)">
      </wm-common-icon>

    </span>

    <wm-common-icon
      class="action-icon"
      [class.icon-disabled]="isRowActionDisabled(row)"
      [data]="{ iconName: editIcon }"
      (click)="editNote(row)">
    </wm-common-icon>

    <wm-common-icon
      class="action-icon"
      [class.icon-disabled]="isRowActionDisabled(row)"
      [data]="{ iconName: deleteIcon }"
      (click)="deleteNote(row)">
    </wm-common-icon>

  </div>
</ng-template>
<!-- End by Vipul on 25-09-2026 -->

<div class="notes-root">
  @if (isInitialLoading) {
    <div class="notes-inline-loader">
      <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
      <wm-common-text [data]="{ text: 'Loading notes details...' }"></wm-common-text>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="notesTab; context: { title: 'Internal Notes', isExternal: false, state: internalState, history: internalNotesHistory }"></ng-container>
    <ng-container *ngTemplateOutlet="notesTab; context: { title: 'External Notes', isExternal: true, state: externalState, history: externalNotesHistory }"></ng-container>
  }

  <ng-template #notesTab let-title="title" let-isExternal="isExternal" let-state="state" let-history="history">
    <div class="category-activity-main-container notes-accordion" [class.expanded]="state.isExpanded">
      <div class="category-activity-header accordion-header" (click)="toggleAccordion(state)">
        <wm-common-text class="accordion-title" [data]="{ text: title }"></wm-common-text>

        @if (state.isExpanded) {
          <ng-template #upArrowTemplate>
            <wm-common-icon [data]="{iconName: upArrowIcon}"></wm-common-icon>
          </ng-template>
          <wm-common-button class="arrowButton" [data]="getAccordionClick(upArrowTemplate, state, 'close')"></wm-common-button>
        } @else {
          <ng-template #downArrowTemplate>
            <wm-common-icon [data]="{iconName: downArrowIcon}"></wm-common-icon>
          </ng-template>
          <wm-common-button class="arrowButton" [data]="getAccordionClick(downArrowTemplate, state, 'open')"></wm-common-button>
        }
      </div>

      @if (state.isExpanded) {
        <div class="category-activity-container accordion-body">
          <div class="notes-context-subheader">
            <wm-common-text [data]="{ text: 'Use this section to add important comments or updates. Review your notes carefully before submitting.' }"></wm-common-text>
          </div>

          <div class="notes-context-row">
            <wm-common-text class="context-text-app" [data]="{ text: 'Application # ' + applicationNumber }"></wm-common-text>
            <span class="context-divider">|</span>
            <wm-common-text class="context-text-note" [data]="{ text: 'Notes' }"></wm-common-text>
          </div>

          <div class="notes-input-row">
            <wm-common-textfield
              class="notes-input-add"
              controlName="newNote"
              [(ngModel)]="state.text"
              [data]="{ label: 'Type Notes Here', placeholder: '', variant: 'outline' }">
            </wm-common-textfield>

            <div class="submit-row">
              <wm-common-button
                class="submit-button"
                [data]="{ text: getSubmitButtonText(isExternal), onClick: submitNote.bind(this, isExternal) }">
              </wm-common-button>
            </div>
          </div>

          <div class="notes-history-card">
            <div class="history-header">
              <wm-common-text class="history-title" [data]="{ text: 'Notes History' }"></wm-common-text>
            </div>

            @if (history.length) {
              <!-- Added by Vipul on 25-09-2026 -->
              <div class="notes-common-table-wrapper">
                <wm-common-table
                  [columns]="columns"
                  [data]="history"
                  [tableType]="'Staff'"
                  [showRowsPerPage]="false"
                  [defaultPageSize]="10"
                  [pageSize]="10"
                  [serverSidePagination]="false"
                  [showTotalRecords]="false"
                  [fixedColumnWidths]="true"
                  tableClass="notes-common-table">
                </wm-common-table>
                <!-- End by Vipul on 25-09-2026 -->
              </div>
            } @else {
              <div class="empty-wrap">No notes available.</div>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>
</div>

<wm-common-confirmation-modal
  [data]="deleteConfirmModal"
  (onYesClick)="confirmDeleteNote()"
  (onNoClick)="closeDeleteNoteModal()"
  [isApplicantMobileview]="true"
>
</wm-common-confirmation-modal>

<wm-common-confirmation-modal
  [data]="markReadConfirmModal"
  (onYesClick)="confirmMarkAsRead()"
  (onNoClick)="closeMarkReadModal()"
  [isApplicantMobileview]="true"
>
</wm-common-confirmation-modal>
